import { LockeClientId } from './types';
import { isUserSignedIn } from './utils/signedInStatusService';
import { getUserInfoFromCookies } from './utils/cookieService';
import { User } from './types';

export const getUser = async (lockeClientId: LockeClientId): Promise<User> => {
  const { token, rcauid, countryCode } = getUserInfoFromCookies();
  let isSignedIn = false;
  if (token) {
    isSignedIn = await isUserSignedIn(token, lockeClientId);
  }
  return {
    rcauid,
    countryCode,
    isSignedIn,
  };
};
